import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsHotelDescStore {
  @observable hotelDesc = null;
  @observable bannerImages = [];
  @observable loading = false;

  @action getData() {
    this.loading = true;

    return apiCaller.CmsHotelDescs.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.hotelDesc = resp.data;
          this.bannerImages = [];
          this.hotelDesc.logoUrl = this.hotelDesc.logoUrl || '';
          this.hotelDesc.bannerUrl = this.hotelDesc.bannerUrl || '';

          if (this.hotelDesc.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.hotelDesc.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.bannerImages = imagesJson;
            } catch {
              this.bannerImages.push({
                id: v4(),
                url: this.hotelDesc.bannerUrl,
                isLoading: false
              });
            }
          }

          this.bannerImages.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.loading = false;
        }
      }
    })
  }

  @action getDataByLanguageCode() {
    this.loading = true;

    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsHotelDescs.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.hotelDesc = resp;
        this.bannerImages = [];
        this.hotelDesc.logoUrl = this.hotelDesc.logoUrl || '';
        this.hotelDesc.bannerUrl = this.hotelDesc.bannerUrl || '';

        if (this.hotelDesc.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.hotelDesc.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.bannerImages = imagesJson;
          } catch {
            this.bannerImages.push({
              id: v4(),
              url: this.hotelDesc.bannerUrl,
              isLoading: false
            });
          }
        }

        this.loading = false;
      }
    })
  }

  @action update() {
    this.loading = true;
    this.hotelDesc.bannerUrl = JSON.stringify(this.bannerImages.filter(fi => fi.url !== ''));
    return apiCaller.CmsHotelDescs.update(this.hotelDesc.id, this.hotelDesc);
  }

  @action setdescription(langId, value) {
    let lang = this.hotelDesc.hotelDescLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setloading(value) {
    this.loading = value;
  }

  @action setbannerUrlById(id, value) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.bannerImages.find(fi => fi.url === '');
    if (!blankImage) {
      this.bannerImages.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setbannerUrlIsLoading(id, isLoading) {
    let image = this.bannerImages.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeBannerImageById(id) {
    this.bannerImages = this.bannerImages.filter(fi => fi.id !== id);
  }

  @action setlogoUrl(value) {
    this.hotelDesc.logoUrl = value;
  }

  @action resetData() {
    this.hotelDesc = null;
  }
}

export default new CmsHotelDescStore();